import styled from "styled-components";

export const AppContainer = styled.div`
  margin: 0 auto;
  max-width: 390px;
  min-height: 100vh;
  background-color: #f0f8ff;
`;
